import React, { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslate } from '@/translations';
import { Title, Icons, PageContainer } from '@/ui/components';
import {
  usePipelineLocations,
  usePipelineGraph,
  usePipelineStatus,
} from '@/api/Pipelines';
import { Button, Card, Col, Row, Select, Spin } from 'antd';
import { PipelineChart } from './components/PipelineChart';
import { PipelineDataGrid } from './components/PipelineDataGrid';
import { filterStatusData, formatStatusData } from './utils';

interface PipelineLocation {
  state?: {
    locationId: string;
  };
}

export const Pipeline = () => {
  const { t } = useTranslate();
  const location = useLocation() as PipelineLocation;
  const stateLocationId = location.state?.locationId ?? '';

  const [locationId, setLocationId] = useState(stateLocationId);
  const [submittedLocationId, setSubmittedLocationId] =
    useState(stateLocationId);

  const { data: locationsData, isFetching: isLocationsLoading } =
    usePipelineLocations();
  const locationItems = (locationsData?.entities || []).map((loc) => ({
    label: loc.city,
    value: loc.id.toString(),
  }));
  const { data: graphData, isFetching: isGraphLoading } = usePipelineGraph();
  const { data: statusData, isFetching: isStatusLoading } =
    usePipelineStatus(submittedLocationId);

  const filteredStatuses = useMemo(
    () => filterStatusData(formatStatusData(statusData?.statuses || []), {}),
    [statusData?.statuses],
  );

  const onClick = () => {
    setSubmittedLocationId(locationId);
  };

  const isLoading = isLocationsLoading || isGraphLoading || isStatusLoading;

  return (
    <Spin spinning={isLoading}>
      <PageContainer>
        <Title title={t('productPipeline')} icon={Icons.compound} />
        <div className="d-flex align-items-center gap-3">
          <Select
            options={locationItems}
            placeholder={t('chooseLocation')}
            onChange={(key) => setLocationId(key)}
            style={{ width: 300 }}
            allowClear
          />
          <Button type="primary" onClick={onClick}>
            {t('go')}
          </Button>
        </div>
        <Row gutter={16}>
          <Col lg={12} md={24}>
            <Card>
              <PipelineDataGrid statusDetailData={filteredStatuses} />
            </Card>
          </Col>
          <Col lg={12} md={24}>
            <Card>
              <PipelineChart graphData={graphData?.entities} />
            </Card>
          </Col>
        </Row>
      </PageContainer>
    </Spin>
  );
};
